// Title Constants
export const HOME_TITLES = {
  CORN_HYBRID_STOCK_OVERVIEW: 'Corn Hybrid stock overview',
  CORN_STOCK: 'Corn Stock',
  UPDATE_HISTORY: 'Update History',
} as const;

// Message Constants
export const HOME_MESSAGES = {
  NO_STOCK_UPDATES_FOUND: 'No stock updates found.',
  STOCK_DETAILS_GUIDE: 'You can add your stock details on 1st or 15th of every month to get started.',
  LAST_UPDATED_ON: 'Last updated on',
  NO_DATA_FOUND_USER: 'No data found for this user',
  NO_UPDATE_HISTORY_FOUND: 'No update history found',
  UPDATE_STOCK_DETAILS_FOR: 'Update Stock details for',
  NEXT_STOCK_UPDATE_DUE_ON: 'Next stock update due on',
  TOTAL: 'Total',
  VIEW_MORE: 'View More',
  KGS: 'Kgs',
  ID_PREFIX: 'ID : ',
  BACK_TO_HISTORY: 'Back to History',
  STOCK_AS_OF: 'Stock as of',
  LOADING_STOCK_DETAILS: 'Loading stock details...',
  NO_STOCK_DETAILS_AVAILABLE: 'No stock details available for',
} as const;

// Update History Page Constants
export const UPDATE_HISTORY_TITLES = {
  UPDATE_HISTORY: 'Update History',
  STOCK_HISTORY: 'Stock History',
  DETAILS_SUFFIX: 'details',
} as const;

export const UPDATE_HISTORY_MESSAGES = {
  STOCK_AS_OF: 'Stock as of',
  LOADING_STOCK_DETAILS: 'Loading stock details...',
  NO_STOCK_DETAILS_AVAILABLE: 'No stock details available for',
  NO_UPDATE_HISTORY_FOUND: 'No update history found',
  EDIT_STOCK_DETAILS: 'Edit Stock Details',
  YOU_CAN_ADD_EDIT_DETAILS: 'You can add/edit details by',
  YOU_CAN_ADD_EDIT_CCM: 'You can add/edit details by',
  TOTAL: 'Total',
  KGS: 'Kgs',
  ID_PREFIX: 'ID : ',
} as const;

// Update Stock Details Page Constants
export const UPDATE_STOCK_TITLES = {
  UPDATE_STOCK_DETAILS: 'Update Stock Details',
  STOCK_DETAILS_AS_OF: 'Stock Details as of',
  SAVE_DETAILS: 'Save Details',
} as const;

export const UPDATE_STOCK_MESSAGES = {
  YOU_CAN_ADD_EDIT_RETAILER: 'You can add/edit details by',
  YOU_CAN_ADD_EDIT_CCM: 'You can add/edit details by',
  NO_STOCK_DATA_RETAILER: 'No stock data available for this retailer.',
  ENTER_HERE: 'Enter here',
  KGS: 'Kgs',
  THIS_FIELD_REQUIRED: 'This field is required',
  QUANTITY_POSITIVE_NUMBER: 'Quantity must be a positive number',
  FILL_REQUIRED_FIELDS: 'Please fill in all required fields with valid quantities.',
  STOCK_SAVED_SUCCESSFULLY: 'Stock details saved successfully',
  SAVE_FAILED: 'Failed to save stock details. Please try again.',
} as const;

// CCM Update History Page Constants
export const CCM_UPDATE_HISTORY_TITLES = {
  UPDATE_BY_YOU: 'Update By You',
  DETAILS_SUFFIX: 'details',
  EDIT_STOCK_DETAILS: 'Edit Stock Details',
} as const;

export const CCM_UPDATE_HISTORY_MESSAGES = {
  LOADING_STOCK_DETAILS: 'Loading stock details...',
  NO_STOCK_DETAILS_AVAILABLE: 'No stock details available for',
  TOTAL: 'Total',
  KGS: 'Kgs',
  RETAILER: 'Retailer',
  ID_PREFIX: 'ID : ',
  N_A: 'N/A',
  YOU_CAN_ADD_EDIT_DETAILS: 'You can add/edit details by today only.',
  YOU_CAN_ADD_EDIT_CCM: 'You can add/edit details by',
  NO_UPDATE_HISTORY_FOUND: 'No update history found',
  TRY_ADJUSTING_SEARCH: 'Try adjusting your search criteria',
} as const;

// CCM Home Page Constants
export const CCM_HOME_TITLES = {
  CORN_HYBRID_STOCK_OVERVIEW: 'Corn Hybrid stock overview',
  UPDATED_BY_YOU: 'Updated By You',
} as const;

export const CCM_HOME_MESSAGES = {
  NO_RETAILERS_LINKED: 'No retailers linked to your account.',
  ONCE_ASSIGNED_MESSAGE: 'Once assigned, you can see and edit their updates here.',
  NO_RETAILERS_FOUND: 'No Results Found',
  NO_RETAILERS_FOUND_MESSAGE: 'We’re sorry we couldn’t find what you’re looking for, please search by correct Retailer name or ID',
  SEARCH_BY_RETAILER_ID: 'Search by retailer or ID',
  ID_PREFIX: 'ID : ',
  KGS: 'Kgs',
  VIEW_HISTORY: 'View History',
  UPDATE_STOCK: 'Update Stock',
  UPDATE_STOCK_DETAILS_ALERT: 'Update stock details',
  NO_UPDATE_HISTORY_FOUND: 'No update history found',
  VIEW_MORE: 'View More',
  VIEW_MORE_ARROW: '>',
  UPDATE_STOCK_DETAILS_BEFORE: 'Update stock details before',
  NEXT_STOCK_UPDATE_DUE_ON: 'Next stock update due on',
  UPDATED: 'Updated',
  RETAILERS: 'Retailers',
  STOCK_AS_OF: 'Stock as of',
  DATA_NOT_AVAILABLE: 'Data Not Available',
} as const;

